import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MailX, CheckCircle2 } from "lucide-react";
import { api, extractError } from "../lib/api";
import { Logo } from "../components/Logo";

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const token = params.get("token") || "";
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      await api.post("/public/email-optout", { email, token });
      setDone(true);
      setError("");
    } catch (e) {
      setError(extractError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--gt-bg-marketing)] flex flex-col">
      <header className="px-6 sm:px-10 py-5 border-b border-[var(--gt-line)] bg-white">
        <Logo size="md" />
      </header>
      <main className="flex-1 flex items-start justify-center px-4 py-12">
        <div className="w-full max-w-lg gt-card bg-white text-center py-8" data-testid="unsubscribe-card">
          {done ? (
            <>
              <CheckCircle2 size={40} className="mx-auto text-emerald-600 mb-3" />
              <h1 className="font-heading text-2xl font-black tracking-tight" data-testid="unsubscribe-done">You're unsubscribed</h1>
              <p className="mt-3 text-sm text-[var(--gt-ink-2)] max-w-sm mx-auto">
                <strong>{email}</strong> won't receive thank-you or follow-up emails anymore.
                You'll still get your tickets, receipts, refund notices and pre-event reminders.
              </p>
            </>
          ) : (
            <>
              <MailX size={40} className="mx-auto text-[var(--gt-ink-2)] mb-3" />
              <h1 className="font-heading text-2xl font-black tracking-tight">Unsubscribe from follow-up emails</h1>
              <p className="mt-3 text-sm text-[var(--gt-ink-2)] max-w-sm mx-auto">
                Stop thank-you and follow-up emails to <strong>{email || "your address"}</strong>?
                Transactional emails (tickets, receipts, refunds, event reminders) are unaffected.
              </p>
              {error && <div className="mt-3 text-xs text-red-600" data-testid="unsubscribe-error">{error}</div>}
              <button
                type="button"
                onClick={confirm}
                disabled={busy || !email || !token}
                className="gt-btn-primary mt-6 disabled:opacity-40"
                data-testid="unsubscribe-confirm-btn"
              >
                {busy ? "Working…" : "Yes, unsubscribe me"}
              </button>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
